class LogoSSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const slider = this.querySelector('.logos-slider-slide');

      if (!slider) return;

      new Swiper(slider, {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 20,
        navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev')
        },
        breakpoints: {
          540: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 3,
          },
          990: {
            slidesPerView: 5,
            spaceBetween: 35,
          },
          990: {
            slidesPerView: 7,
            spaceBetween: 35,
          }
        }
      });
    }
  }

  customElements.define('logos-slider', LogoSSlider);